import React from 'react';
import NextScript from 'next/script';
import { useIntl } from 'react-intl';
import { getBACNumberFromJWT, getDomainConfig, isCSR, isCustomerLoggedIn } from '@raisin/cp-utils';
const Script = ({ hasDefaultGTMConsent }) => {
    const intl = useIntl();
    const USERCENTRIC_ID = getDomainConfig(intl.locale || 'de-DE').userCentricId;
    const customerBACNumber = isCSR() && isCustomerLoggedIn() ? getBACNumberFromJWT() : null;
    return (React.createElement(React.Fragment, null,
        hasDefaultGTMConsent && (React.createElement(NextScript, { id: "gtag-consent", "data-testid": "gtag-consent" }, `
          /*  Tag Manager Snippet */
            window.dataLayer = window?.dataLayer || [];
            
            function gtag() {
                dataLayer.push(arguments);
            }
                        
            gtag("consent", "default", {
                ad_user_data: "denied",
                ad_personalization: "denied",
                ad_storage: "denied",
                analytics_storage: "denied",
                wait_for_update: 2000,
              });
            
            gtag("set", "ads_data_redaction", true);

             ${customerBACNumber
            ? `window.dataLayer.push({ customer_id: "${customerBACNumber}" });`
            : ''}
          /*  Tag Manager Snippet END */
        `)),
        React.createElement(NextScript
        /*
        // @ts-ignore */
        , { 
            /*
            // @ts-ignore */
            type: "text/javascript", src: "https://app.usercentrics.eu/browser-ui/latest/loader.js", id: "usercentrics-cmp", "data-settings-id": USERCENTRIC_ID }),
        React.createElement(NextScript
        /*
        // @ts-ignore */
        , { 
            /*
            // @ts-ignore */
            type: "application/javascript", src: "https://privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js" }),
        React.createElement(NextScript, { id: "hide-uc-banner" }, `
          if (window.location.href.indexOf("suppress_uc_cmp=x") > -1) {
              var UC_UI_SUPPRESS_CMP_DISPLAY = true;
          }
        `)));
};
export default Script;
//# sourceMappingURL=index.js.map